/* eslint-disable no-multi-spaces */

// function msToTime_OLD(duration) {
//   if (!duration) return '0 sec'

//   // let milliseconds = parseInt((duration % 1000) / 100, 10);
//   let seconds = Math.floor((duration / 1000) % 60);
//   let minutes = Math.floor((duration / (1000 * 60)) % 60);
//   let hours = Math.floor((duration / (1000 * 60 * 60)));

//   if (hours) minutes = (minutes < 10) ? `0${minutes}` : minutes;
//   if (minutes) seconds = (seconds < 10) ? `0${seconds}` : seconds;

//   return `${hours ? `${hours} h ` : ''}${
//     hours || minutes !== '00' ? `${minutes} min ` : ''}${seconds} sec`;
// }

export function msToTime(duration) {
  if (!duration) return '00:00:00'

  let seconds = Math.floor(duration % 60);
  let minutes = Math.floor((duration / 60) % 60);
  let hours = Math.floor((duration / (60 * 60)));

  hours   = (hours < 10)   ? `0${hours}`   : hours;
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  seconds = (seconds < 10) ? `0${seconds}` : seconds;

  return `${hours}:${minutes}:${seconds}`;
}

export function timeToMs(time) {
  if (!time || time.length !== 8) return 0

  let [hours, minutes, seconds] = time.split(':');
  hours = Number(hours);
  minutes = Number(minutes);
  seconds = Number(seconds);
  return ((((hours * 60) + minutes) * 60) + seconds) * 1000
}

export function dateToTime(date) {
  if (!date) return '00:00:00'

  let seconds = date.getSeconds()
  let minutes = date.getMinutes()
  let hours = date.getHours()

  hours   = (hours < 10)   ? `0${hours}`   : hours;
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  seconds = (seconds < 10) ? `0${seconds}` : seconds;

  return `${hours}:${minutes}:${seconds}`;
}
